import { createContext, useEffect, useState } from "react";

export const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [token, setToken] = useState(() => {
    return localStorage.getItem("arena_xp_token");
  });

  const [signedUp, setSignedUp] = useState(() => {
    const stored = localStorage.getItem("signedUp");
    return stored ? JSON.parse(stored) : false;
  });

  const [profile, setProfile] = useState(() => {
    const stored = localStorage.getItem("profile");
    return stored ? JSON.parse(stored) : null;
  });

  const logout = () => {
    setToken(null);
    setProfile(null);
    setSignedUp(false);

    localStorage.removeItem("arena_xp_token");
    localStorage.removeItem("user");
    localStorage.removeItem("profile");
    localStorage.removeItem("signedUp");
  };

  useEffect(() => {
    if (profile) {
      localStorage.setItem("profile", JSON.stringify(profile));
    }
    if (token) {
      localStorage.setItem("arena_xp_token", token);
    }
    localStorage.setItem("signedUp", JSON.stringify(signedUp));
  }, [signedUp, profile, token]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "arena_xp_token" && event.newValue === null) {
        logout();
        window.location.href = "/";
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <UserContext.Provider
      value={{
        token,
        setToken,
        signedUp,
        setSignedUp,
        profile,
        setProfile,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
